// src/lib/listingStore.js
const KEY = "wow_market_listings_v1";

export function loadListings() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveListings(listings) {
  try {
    localStorage.setItem(KEY, JSON.stringify(listings || []));
  } catch {
    // ignore
  }
}

export function upsertListing(listings, listing) {
  const arr = Array.isArray(listings) ? [...listings] : [];
  const idx = arr.findIndex((x) => x.id === listing.id);
  if (idx >= 0) arr[idx] = listing;
  else arr.unshift(listing);
  saveListings(arr);
  return arr;
}

export function getListingById(listings, id) {
  return (listings || []).find((x) => String(x.id) === String(id));
}
